import { render, staticRenderFns } from "./StatisticsSubscriptionsDynamic.vue?vue&type=template&id=28dc9184&scoped=true&"
import script from "./StatisticsSubscriptionsDynamic.vue?vue&type=script&lang=js&"
export * from "./StatisticsSubscriptionsDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc9184",
  null
  
)

export default component.exports